// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__bf7oN","head":"ProcedureTableInfo_head__6r0M_"};